var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyChannelsArrow = function SvgEmptyChannelsArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 51,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m44.926 17.256-12.085 9.73a6.3 6.3 0 0 1-7.78 0l-12.19-9.73",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M15.516 1.5h26.712a14.05 14.05 0 0 1 10.144 4.506A14.21 14.21 0 0 1 56.13 16.5v18.496a14.21 14.21 0 0 1-3.757 10.494 14.05 14.05 0 0 1-10.144 4.506H15.516c-8.273 0-13.849-6.73-13.849-15V16.5c0-8.27 5.576-15 13.849-15",
    clipRule: "evenodd"
  })));
};
export default SvgEmptyChannelsArrow;